<template>
    <div id="ssoFindPassword">
    <!-- 第一步 -->
        <div class="findTitle" v-if="pageNum==1">
            <span class="phoneFind">{{leftText}}</span>
            <span v-on:click="findTab()" class="emailFind">{{rightText}}</span>
        </div>
        <div class="findPassWin" v-if="pageNum==1 && firstTab==1">
            <!-- 手机号 -->
            <input class="findPssInput longInput" maxlength="11" type="text" v-model="phone" placeholder="手机号">
            <p class="errTip" v-if="phoneErr">{{phoneErrTip}}</p>
            <!-- 短信验证码 6位 -->
            <input class="findPssInput midInput" type="text" v-model="phoneCode" placeholder="短信验证码" maxlength="6" v-on:blur="checkPhoneCode">
            <input type="button" class="codeImg getPhoneCode" v-bind:value="codeTime" v-on:click="getPhoneCode" v-bind:disabled="noPhoneSend">
            <p class="errTip" v-if="phoneCodeErr">{{phoneCodeErrTip}}</p>
            <div class="noneDiv"></div>
            <!-- 手机找回确认 -->
            <p class="errTip msgErrTip" v-if="phoneMsgErr">{{phoneMsgErrTip}}</p>
            <div class="confirmBtn">
                <input class="findPssInput longInput confirm" type="button" v-bind="noCommitPhone" value="确定"
                       v-on:click="commitPhone" v-on:blur="clearTips" v-bind:disabled="noSend">
                <img src="./images/loading.gif" v-if="showLoading">
            </div>
        </div>
        <div class="findPassWin" v-if="pageNum==1 && firstTab==2">
            <!-- 邮箱找回 -->
            <input class="findPssInput longInput" type="text" v-model="email" placeholder="邮箱">
            <p class="errTip" v-if="emailErr">{{emailErrTip}}</p>
            <div class="noneDiv"></div>
            <!-- 邮箱发送验证码按钮 -->
            <p class="errTip msgErrTip" v-if="emailMsgErr">{{emailMsgErrTip}}</p>
            <div class="confirmBtn">
                <input class="findPssInput longInput confirm" type="button" value="发送" v-on:click="getEmailUrl" v-bind:disabled="noSend">
                <img src="./images/loading.gif" v-if="showLoading">
            </div>
        </div>
    <!-- 第二步 新密码 -->
        <div class="findTitle" v-if="pageNum==2">
            <span class="phoneFind">重置密码</span>
        </div>
        <div class="findPassWin" v-if="pageNum==2">
            <!-- 新密码 -->
            <div class="passBox">
                <input class="findPssInput longInput pass" type="password" v-model="password" placeholder="输入新密码" v-if="passType1">
                <input class="findPssInput longInput pass" type="text" v-model="password" placeholder="输入新密码" v-if="!passType1">
                <img class="passEye" src="./images/open.png" alt="" v-if="passType1" v-on:click="changePassType(1)">
                <img class="passEye" src="./images/close.png" alt="" v-if="!passType1" v-on:click="changePassType(1)">
            </div>
            <p class="errTip" v-if="passErr">{{passErrTip}}</p>
            <!-- 确认新密码 -->
            <div class="passBox">
                <input class="findPssInput longInput" type="password" v-model="confPass" placeholder="再次确认新密码" v-if="passType2">
                <input class="findPssInput longInput" type="text" v-model="confPass" placeholder="再次确认新密码" v-if="!passType2">
                <img class="passEye" src="./images/open.png" alt="" v-if="passType2" v-on:click="changePassType(2)">
                <img class="passEye" src="./images/close.png" alt="" v-if="!passType2" v-on:click="changePassType(2)">
            </div>
            <p class="errTip" v-if="confPassErr">{{confPassErrTip}}</p>

            <div class="noneDiv"></div>
            <!-- 确认新密码按钮 -->
            <p class="errTip msgErrTip" v-if="confMsgErr">{{passMsgErrTip}}</p>
            <div class="confirmBtn">
                <input class="findPssInput longInput confirm" type="button" value="确定" v-on:click="confirmPass" v-on:blur="clearTips" v-bind:disabled="noSend">
                <img src="./images/loading.gif" v-if="showLoading">
            </div>
        </div> 
    <!-- 第三步 提交后的提示 -->
        <div class="findPassWin" v-if="pageNum==3">
            <!-- 密码提交提示 -->
            <div class="passBox" v-if="commitType=='phone'">
                <p class="successTitle">密码修改成功</p>
                <p class="successJump">{{jumpTimer}}S后自动跳转至登录页</p>
                <router-link to="/login" class="nowGo">立刻去登录</router-link>
            </div>
            <!-- 获取邮箱验证码成功提示 -->
            <div class="passBox" v-if="commitType=='email'">
                <p class="successTitle">验证码发送成功</p>
                <p class="successJump Jump1">请前往您的邮箱按指示完成激活操作</p>
                <p class="successJump">{{jumpTimer}}S后自动跳转至登录页</p>
                <router-link to="/login" class="nowGo">返回登录页</router-link>
            </div>
            
        </div>
        <popup :title="dialogTitle" v-if="showDialog" :showClose="showClose" :showPopBtn="showPopBtn">

        </popup>
    </div>
</template>
<script>
    import api from 'sso.server';
    import reg from 'reg';
    import aes from 'AES';
   
    module.exports = Vue.component('sso-findPassword',{
        data:function() {
            return {
                firstTab:1,             // 手机邮箱切换
                pageNum:1,              // 找回密码步骤

                phone:'',               // 手机号
                phoneErr:false,         // 手机号错误
                phoneErrTip:null,

                phoneCode:'',           // 短信验证码
                phoneCodeErr:false,     // 短信验证码错误
                phoneCodeErrTip:null,   

                email:'',               // 邮箱
                emailErr:false,         // 邮箱错误
                emailErrTip:null,

                password:'',            // 密码
                passErr:false,          // 密码错误
                passErrTip:null,

                confPass:'',            // 确认密码
                confPassErr:false,      // 确认密码错误
                confPassErrTip:null,

                passType1:true,         // 密码显隐格式
                passType2:true,         // 确认密码显隐格式

                codeTime:'发送验证码',  // 获取验证码按钮文本     

                phoneMsgErr:false,      // 手机找回--后台错误提示
                phoneMsgErrTip:null,
                emailMsgErr:false,      // 邮箱找回--后台错误提示
                emailMsgErrTip:null,
                passMsgErr:false,       // 手机找回提交新密码--后台错误提示
                passMsgErrTip:null,

                noPhoneSend:false,      // 禁止发送手机验证
                noEmailSend:false,      // 禁止发送邮箱验证
                noCommitPhone:false,    // 禁止重复提交手机验证信息
                noCommitNewPass:false,  // 禁止重复提交新密码

                jumpTimer:15,           // 全部提交后跳转至登录前的倒计时
                commitType:null,        // 最后一步：phone:密码提交后的结束框
                                        //           email:邮箱提交后的结束框
                leftText: "手机找回",
                rightText: "邮箱找回",

                dialogTitle:"",   // 注册成功之后的提示
                showDialog:false,        // 注册之后提示窗口
                showPopBtn:false,
                showClose:false,

                changeType:0,             // 手机是1,邮件是2
                emailKey:"",
                noSend:false,              // 是否允许点击确认按钮提交数据
                showLoading:false          // loading加载图片
            }
        },
        mounted:function(){
            let firstSplit = location.href.split("?")[1];
            if (firstSplit !== undefined) {
                let secSplit = firstSplit.split("#")[0];
                let arr = secSplit.split("&");
                this.appKey = arr[0].split("=")[1];
                this.url = arr[1].split("=")[1];
            }
        },
        methods:{
            // 密码登录和快速登录切换
            findTab:function(){
                if (this.leftText == "手机找回") {
                    this.rightText = "手机找回";
                    this.leftText = "邮箱找回";
                    this.firstTab = 2;
                } else {
                    this.rightText = "邮箱找回";
                    this.leftText = "手机找回";
                    this.firstTab = 1;
                }
                this.clearTips();

            },
            // 密码显示隐藏切换
            changePassType:function(num){
                let type = 'passType'+num;
                this[type] = !this[type];
            },
            // 校验手机验证码
            checkPhoneCode:function(){
                if (this.phoneCode.length == 0) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码不能为空";
                    this.fastPhoneCode = false;
                } else if (!reg.phoneCode(this.phoneCode)) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码格式不正确";
                    this.fastPhoneCode = false;
                } else {
                    this.phoneCodeErr = false;
                    this.phoneCodeErrTip = "";
                    this.fastPhoneCode = true;
                }

            },
            // 前端基本校验
            webCheck:function(type){
                let state;
                if(type=="phone"){
                    if(this.phone.length == 0){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                        state = false;
                    }else if(!reg.validPhone(this.phone)){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号格式不正确';
                        state = false;
                    }else{
                        state = true;
                    }
                }else if(type=="email"){
                    if(this.email.length == 0){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                        state = false;
                    }else if(!reg.validEmail(this.email)){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱格式不正确';
                        state = false;
                    }else{
                        state = true;
                    }
                }
                return state;
            },
            // 检测邮箱是否可用
            checkEmail:function(){
                let def = $.Deferred();
                let _this = this;
                this.noEmailSend = true;             // 验证邮箱期间禁止重复验证
                api.checkEmail(this.email)
                .then(function(res){
                    if((res.header&&res.header.code)==1){
                        def.resolve({
                            code:res.header.code,
                            msg:res.header.msg,
                        });
                    }else{
                        _this.noEmailSend = true;     // 邮箱不可用，放开发送验证码按钮
                        def.reject({                  // 返回不可用原因
                            code:res.header.code,
                            msg:res.header.msg,
                        });
                    }
                },function(res){
                    _this.noEmailSend = true;         // 邮箱验证请求失败，放开发送验证码按钮
                    def.reject({
                        code:0,
                        msg:'网络异常',
                    });
                })
                return def.promise();
            },
            // 检测手机号是否可用
            checkPhone:function(phone){
                let def = $.Deferred();
                let _this = this;
                this.noPhoneSend = true;
                let getPhoneCode = {
                    phone: phone
                }// 验证手机号期间禁止重复验证
                api.checkPhoneFindPassword(getPhoneCode)
                .then(function(res){
                    if((res.data.header && res.data.header.code)==200){
                        def.resolve({
                            code:res.data.header.code,
                            msg:res.data.header.msg,
                        });
                    }else{
                        _this.noPhoneSend = true;     // 手机号不可用，放开获取验证码按钮
                        def.reject({                  // 返回不可用原因
                            code:res.data.header.code,
                            msg:res.data.header.msg,
                        });
                    }
                },function(res){
                    _this.noPhoneSend = true;         // 手机号验证请求失败，放开获取验证码按钮
                    def.reject({
                        code:0,
                        msg:'网络异常',
                    });
                })
                return def.promise();
            },
            // 获取短信验证码
            getPhoneCode:function(){
                let state = this.webCheck('phone');
                if(!state){
                   return;
                }else{
                    let _this = this;
                    this.checkPhone(this.phone)
                    .then(function(res){                    // 手机号验证成功，开始倒计时
                        let time = 60;
                        _this.codeTime = '60S';
                        let timer = setInterval(function(){
                            if(time != 1){
                                time--;
                                _this.codeTime = time + 'S';
                            }else{
                                _this.codeTime = '重新发送';
                                _this.noPhoneSend = false;       // 倒计时结束，放开获取验证码按钮
                                clearInterval(timer);
                            }
                        },1000);
                    },function(res){
                        _this.phoneErr = true;
                        _this.phoneErrTip = res.msg;
                        _this.noPhoneSend = false;
                    })
                }     
            },
            // 获取邮箱激活链接
            getEmailUrl:function(){
                if (!this.emailErr) {
                    if(this.email.length == 0){
                        this.emailMsgErr = true;
                        this.emailMsgErrTip = '邮箱不能为空';
                    } else {
                        this.noSend = true;
                        let _this = this;
                        _this.showLoading = true;
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let param = {
                            email : aes.getAes(_this.email, timer),
                            timer : timer
                        }
                        api.findPassword(param)
                        .then(function(res){
                            if((res.data.header && res.data.header.code)==200){
                                _this.dialogTitle = "发送成功";
                                _this.showDialog = true;
                                setTimeout(function(){
                                    _this.showDialog = false;
                                    _this.$router.push({
                                        path:'/login'
                                    })
                                }, 1000);
                            }else{
                                _this.noEmailSend = false;
                                _this.emailMsgErr = true;
                                _this.emailMsgErrTip = res.data.header.msg;
                            }
                             _this.showLoading = false;
                             _this.noSend = false;
                        },function(res){
                            _this.noEmailSend = false;
                            _this.emailMsgErr = true;
                            _this.emailMsgErr = '网络异常';
                        })
                    }
                }
            },
            // 提交手机号和验证码
            commitPhone:function(){
                if (!this.phoneErr && !this.phoneCodeErr) {
                    if(this.phone.length == 0){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                        this.phoneMsgErr = false;
                    } else if(this.phoneCode.length == 0){
                        this.phoneCodeErr = true;
                        this.phoneCodeErrTip = '短信验证码不能为空';
                        this.phoneMsgErr = false;
                    } else {
                        this.noCommitPhone = true;
                        this.noSend = true;
                        this.showLoading = true;
                        let _this = this;
                        let param = {
                            phone : this.phone,
                            phoneCode : this.phoneCode
                        };
                        api.phoneCodeForFindPassword(param)
                        .then(function(res){
                            if((res.data.header && (res.data.header.code == 200)) == 1){
                                _this.pageNum = 2;
                                _this.noCommitPhone = false;
                                _this.changeType = 1;
                            }else{
                                _this.noCommitPhone = false;
                                _this.phoneMsgErr = true;
                                _this.phoneMsgErrTip = res.data.header.msg;
                                _this.phoneCode = "";
                            }
                            _this.showLoading = false;
                            _this.noSend = false;
                        },function(res){
                            _this.noSend = false;
                            _this.noCommitPhone = false;
                            _this.phoneMsgErr = true;
                            _this.phoneMsgErrTip = '网络异常';
                        })
                    }
                }
            },
            // 提交新密码
            confirmPass:function(){
                if (!this.passErr && !this.confPassErr) {
                    if(!this.password){
                        this.passMsgErr = true;
                        this.passMsgErrTIP = "密码不能为空";
                    }else if(!this.confPass){
                        this.confPassErr = true;
                        this.confPassErrTip = "确认密码不能为空"
                    } else {
                        this.noSend = true;
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let _this = this;
                        _this.showLoading = true;
                        if (_this.changeType == 1) {
                            let param = {
                                phone:aes.getAes(_this.phone, timer),
                                password:aes.getAes(_this.password, timer),
                                timer : timer,
                                phoneCode : _this.phoneCode
                            };
                            api.commitNewPassWord(param)
                            .then(function(res){
                                if(res.data.header && res.data.header.code == 200){
                                    _this.dialogTitle = "重置成功";
                                    _this.showDialog = true;
                                    setTimeout(function(){
                                        _this.showDialog = false;
                                        _this.$router.push({
                                            path:'/login'
                                        })
                                    }, 1000);
                                }else{
                                    _this.noCommitNewPass = false;
                                    _this.passMsgErr = true;
                                    _this.passMsgErrTip = res.data.header.msg;
                                }
                                this.noSend = false;
                                _this.showLoading = false;
                            },function(res){
                                _this.noCommitNewPass = false;
                                _this.passMsgErr = true;
                                _this.passMsgErrTip = '网络异常';
                            })
                        } else if (_this.changeType == 2) {
                            let param = {
                                password:aes.getAes(_this.password, timer),
                                timer : timer,
                                key : _this.emailKey
                            };
                            api.updatePasswordEmail(param)
                            .then(function(res){
                                if(res.data.header && res.data.header.code == 200){
                                    _this.dialogTitle = "重置成功";
                                    _this.showDialog = true;
                                    setTimeout(function(){
                                        _this.showDialog = false;
                                        _this.$router.push({
                                            path:'/login'
                                        })
                                    }, 1000);
                                }else{
                                    _this.passMsgErr = true;
                                    _this.passMsgErrTip = res.data.header.msg;
                                }
                                _this.noSend = false;
                                _this.showLoading = false;
                            },function(res){
                                _this.noCommitNewPass = false;
                                _this.passMsgErr = true;
                                _this.passMsgErrTip = '网络异常';
                            })

                        }
                    }
                }
            },
            // 返回登录页
            backLogin:function(){
                let newHref = window.location.href.split('#/')[0];
                window.location.href = newHref;
            },
            clearTips:function(){
                this.phoneMsgErr = false;
                this.phoneCodeErr = false;
                this.emailMsgErr = false;
                this.passMsgErr = false;
            },
        },
        watch:{
            'email':{
                'handler':function(val){
                    if(!val){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱不能为空';
                    }else if(!reg.validEmail(val)){
                        this.emailErr = true;
                        this.emailErrTip = '邮箱格式不正确';

                    }else{
                        this.emailErr = false;
                    }
                    this.emailMsgErr = false;
                }
            },
            'phone':{
                'handler':function(val){
                    if(!val){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                    }else if(!reg.validPhone(val)){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号格式不正确';
                    }else{
                        this.phoneErr = false;
                    }
                }
            },
            'password':{
                'handler':function(val){
                    if(!val){
                        this.passErr = true;
                        this.passErrTip = '密码不能为空';
                    }else if(!reg.validPassword(val)){
                        this.passErr = true;
                        this.passErrTip = '密码格式不正确';
                    }else{
                        this.passErr = false;
                    }
                }
            },
            'confPass':{
                'handler':function(val){
                    if(!val){
                        this.confPassErr = true;
                        this.confPassErrTip = '确认密码不能为空';
                    }else if(val != this.password){
                        this.confPassErr = true;
                        this.confPassErrTip = '两次密码不一致';
                    }else{
                        this.confPassErr = false;
                    }
                }
            },
            popClose: function(){
                this.showPopUp = false;
            },
        },
        mounted:function(){
            let href = location.href.split("?")[1];
            if (href === undefined) {
                this.pageNum = 1;
            } else {
                let arr = href.split("=")
                if (arr[0] == 'key' && arr.length != 0) {
                    this.pageNum = 2;
                    this.changeType = 2;
                    this.emailKey = arr[1];
                } else {
                    this.pageNum = 1;
                }
            }

        }
    })  
</script>
<style lang="scss" scoped>
    #ssoFindPassword{
        width:100%;
         .findTitle{
            width: 284px;
            margin: 0 auto;
            margin-top: 18px;
            margin-bottom:7px;
            height:30px;
            span{
                display:inline-block;
                height:30px;
                line-height:38px;
                cursor:pointer;
                float:left;
                &.phoneFind{
                    color:#364983;
                    font-size: 22px;
                }
                &.emailFind{
                    color: #666666;
                    font-size: 16px;
                    float: right;
                    &:hover{
                        color:#364983;
                    }
                }
            }
        }
        .findPassWin{
            width: 284px;
            margin: 0 auto;
            .findPssInput{
                height:42px;
                background-color: #fff;
                border:none;
                border-radius:6px;
                padding-left:10px;
                font-size:16px;
                color:#666;
                margin-top:12px;
                margin-bottom: 7px;
            }
            .longInput{
                width: 284px;
            }
            .midInput{
                width:180px;
            }
            .codeImg{
                width:90px;
                height:42px;
                float:right;
                margin-top:12px;
                border-radius:6px;
                cursor:pointer;
                &.getPhoneCode{
                    display:inline-block;
                    border:none;
                    background-color:  #364983;
                    font-size:12px;
                    color:#fff;
                    text-align:center;
                    line-height:42px;
                    &:hover{
                        background: #435898;
                    }
                }
            }
            .passBox{
                position:relative;
                .passEye{
                    position:absolute;
                    width: 17px;
                    height: 17px;
                    right:22px;
                    top: 24.5px;
                    cursor:pointer;
                }
                .successTitle{
                    text-align:center;
                    font-size:24px;
                    color:#364983;
                }
                .successJump{
                    text-align:center;
                    font-size:12px;
                    margin-top:15px;
                    margin-bottom:35px;
                    color:#fff;
                    &.Jump1{
                        font-size:14px;
                        margin-bottom:15px;
                    }
                }
                .nowGo{
                    display:inline-block;
                    width:70%;
                    height:35px;
                    margin-left:15%;
                    text-align:center;
                    font-size:18px;
                    line-height:35px;
                    background-color: #364983;
                    color:#fff;
                    border-radius:5px;
                }
            }
            .confirmBtn{
                position: relative;
                .confirm{
                    background-color: #364983;
                    color:#fff;
                    font-size:18px;
                    cursor:pointer;
                    margin-top:12px;
                    margin-bottom: 18px;
                    &:hover{
                        background: #435898;
                    }
                }
                img{
                    width: 18px;
                    height: 18px;
                    position: absolute;
                    left: 100px;
                    top:24px;
                    background: 0;
                }
            }

            .errTip{
                font-size:12px;
                line-height:18px;
                color:#CE2E2E;
                padding-left:10px;
                &.msgErrTip{
                    line-height:22px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/sso/components/findPassword/findPassword.vue